module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fYDqG"))).then(() => parcelRequire('dJXJK'));